// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('landingPage')
  .directive('giHeroCarousel', ($document, $timeout, $interval) => ({
    restrict: 'A',

    link(scope, element, attrs) {
      const heroSlides = element.find('.hero-slides');
      const slideSelector = '.hero-slides > article';
      scope.slides = element.find(slideSelector);
      const slideWidth = $(scope.slides[0]).width();
      let slideShow = null;
      let waitForSlideShow = null;
      const animationSpeed = 600;
      const intervalSpeed = 6000;
      let animating = null;
      let slid = 0;

      angular.forEach(scope.slides, function (slide, index) {
        const items = $(slide).find('a');
        const randomIndex = Math.floor(Math.random() * items.length);
        return angular.forEach(items, function (item, index) {
          if (index === randomIndex) {
            if (randomIndex > 0) {
              // The first tile loads ready to go.
              const image = $(item).data().src;
              const caption = $(item).html();
              return $(item).html(
                `<figure><img src=\"${image}\" /><figcaption>${caption}</figcaption></figure>`
              );
            }
          } else {
            return $(item).hide();
          }
        });
      });

      scope.clickNext = function ($event) {
        $event.preventDefault();
        nextSlide();
        return stopSlideShow();
      };

      var nextSlide = function ($event) {
        if (animating && animating.$$state.status === 0) {
          return false;
        }
        const firstSlide = $(scope.slides[0]);
        firstSlide.width(0);
        scope.slides
          .removeClass('active')
          .removeClass('left-curtain')
          .removeClass('right-curtain');
        $(scope.slides[1]).addClass('left-curtain');
        $(scope.slides[2]).addClass('active');
        $(scope.slides[3]).addClass('right-curtain');
        animating = $timeout(function () {
          firstSlide.remove();
          $(scope.slides[scope.slides.length - 1]).after(firstSlide);
          firstSlide.find('a').click(fromInactive);
          const video = firstSlide.find('video');
          if (video.length > 0) {
            video.get(0).play();
          }
          firstSlide.width('');
          setCarouselOffset();
          return (scope.slides = element.find(slideSelector));
        }, animationSpeed);
        return false;
      };

      scope.clickPrev = function ($event) {
        $event.preventDefault();
        previousSlide();
        return stopSlideShow();
      };

      var previousSlide = function () {
        if (animating && animating.$$state.status === 0) {
          return false;
        }
        const lastSlide = $(scope.slides[scope.slides.length - 1]);
        lastSlide.width(0).remove();
        $(scope.slides[0]).before(lastSlide);
        lastSlide.find('a').click(fromInactive);
        $timeout(function () {
          lastSlide.width('');
          const video = lastSlide.find('video');
          if (video.length > 0) {
            video.get(0).play();
          }
          setCarouselOffset();
          scope.slides = element.find(slideSelector);
          scope.slides
            .removeClass('active')
            .removeClass('left-curtain')
            .removeClass('right-curtain');
          $(scope.slides[0]).addClass('left-curtain');
          $(scope.slides[1]).addClass('active');
          return $(scope.slides[2]).addClass('right-curtain');
        }, 1);
        animating = $timeout(() => false, animationSpeed);
        return false;
      };

      var fromInactive = function ($event) {
        if (animating && animating.$$state.status === 0) {
          return false;
        }
        if (!$(this).closest('article').hasClass('active')) {
          $event.preventDefault();
          if ($(this).closest('article').hasClass('left-curtain')) {
            previousSlide();
            stopSlideShow();
          }
          if ($(this).closest('article').hasClass('right-curtain')) {
            nextSlide();
            return stopSlideShow();
          }
        }
      };

      var setCarouselOffset = function () {
        const offset = slideWidth * 1.5 - $document.width() / 2;
        return heroSlides.css('marginLeft', offset * -1);
      };

      const startSlideShow = function () {
        stopSlideShow();
        return (slideShow = $interval(function () {
          nextSlide();
          slid++;
          if (slid >= scope.slides.length) {
            return stopSlideShow();
          }
        }, intervalSpeed));
      };

      var stopSlideShow = function () {
        if (waitForSlideShow) {
          $timeout.cancel(waitForSlideShow);
        }
        if (slideShow) {
          return $interval.cancel(slideShow);
        }
      };

      const keyControls = function (event) {
        if (event.keyCode === 39) {
          nextSlide();
          stopSlideShow();
        }
        if (event.keyCode === 37) {
          previousSlide();
          return stopSlideShow();
        }
      };

      const mobileLinkVideos = () =>
        (() => {
          const result = [];
          for (let slide of $(heroSlides).children()) {
            let videoLink = $(slide).find('.card-link');
            if (videoLink.length > 0) {
              videoLink = videoLink.get(0);
              $(videoLink).detach();
              result.push(
                $(slide).find('figcaption').contents().wrap(videoLink)
              );
            } else {
              result.push(undefined);
            }
          }
          return result;
        })();

      const init = function () {
        const lastSlide = $(scope.slides[scope.slides.length - 1]);
        lastSlide.remove();
        $(scope.slides[0]).before(lastSlide);
        lastSlide.find('a').click(fromInactive);
        scope.slides = element.find(slideSelector);
        scope.slides.removeClass('active');
        $(scope.slides[0]).addClass('left-curtain');
        const video = $(scope.slides[0]).find('video');
        if (
          video.get(0) &&
          video.get(0).toString() !== '[object HTMLUnknownElement]'
        ) {
          // Phantomjs does not recognize the html5 video element, so this second check allows tests to pass
          video.get(0).play();
        }
        $(scope.slides[1]).addClass('active');
        $(scope.slides[2]).addClass('right-curtain');
        setCarouselOffset();
        return (waitForSlideShow = $timeout(
          () => startSlideShow(),
          intervalSpeed
        ));
      };

      const initMobile = function () {
        $(heroSlides).addClass('scroll-area');
        $(slideSelector).addClass('active');
        $('.slide-control').hide();
        return mobileLinkVideos();
      };

      heroSlides.find('a').click(fromInactive);

      $(window).resize(setCarouselOffset);

      element.mouseover(() => $(window).on('keydown', keyControls));

      element.mouseout(() => $(window).off('keydown', keyControls));

      $(window).keydown(keyControls);

      if (Modernizr.touch && isMobile) {
        return initMobile();
      } else {
        return init();
      }
    },
  }));
